import TableList from "@components/templates/tablelist";
import { HttpUcAnnouncementList, HttpUcAnnouncementSetActive,HttpDelUcAnnouncement } from "@/service/ucadm";
import compUpdate from "./update";
import announceModal from './detailmodal.vue'
import './announce.scss'
export default {
    mixins: [TableList],
    data() {
        return {
            isMixin: true,
            // formData: {},
            Tools: { show: true },
            Searchs: {
                show: true,
                labelWidth: 90
            },
            Plugins: { show: true }
        };
    },
    components: {
        compUpdate,
        announceModal
    },
    methods: {
        ajaxRequest: HttpUcAnnouncementList,
        handleOperates(params = "", type, batch) {
            if (batch) {
                params = (params || this.checkedData.join(",")) + "";
                if (!params.length)
                    return this.$VMessage.warning("请选择至少一条数据");
            }
            switch (type) {
                case 'query':
                    this.operate = {
                        show: true,
                        id: params,
                        isQuery: true,
                        title: '公告预览',
                        component: 'announceModal',
                        page: this.formData.page,
                        row: this.formData.rows,
                        width: 800,
                        showFooter: false
                    }
                    break
                case "add":
                    this.operate = {
                        show: true,
                        params: { id: params, type: "add" },
                        title: "添加系统公告",
                        component: "compUpdate",
                        width: 1000,
                        showFooter: false
                    };
                    break;
                case "edit":
                    this.operate = {
                        show: true,
                        params: { id: params, type: "edit" },
                        title: "编辑系统公告",
                        component: "compUpdate",
                        width: 1000,
                        showFooter: false
                    };
                    break;
                case "del":
                    this.operate = {
                        show: true,
                        alert: "primary",
                        params: { id: params },
                        title: "删除该系统公告",
                        ajaxRequest: HttpDelUcAnnouncement
                    };
                    break;
                case 'active':
                case 'deactive':
                    this.operate = {
                        show: true,
                        alert: "primary",
                        params: { id: params },
                        title: `${type === 'active' ? '启用' : '停用'}该系统公告`,
                        ajaxRequest: HttpUcAnnouncementSetActive,
                        interceptRequest: (data) => {
                            return {
                                ...data,
                                active: type === 'active' ? 1 : 0
                            }
                        }
                    };
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id } = row;
            return [
                {
                    label: '查看',
                    show: true,
                    params: id,
                    operate: 'query'
                },
                // {
                //     label: "编辑",
                //     show: true,
                //     params: id,
                //     operate: "edit"
                // },
                {
                    label: row.active === 1 ? '停用' : '启用',
                    show: true,
                    params: id,
                    operate: row.active === 1 ? 'deactive' : 'active'
                },
                // {
                //     label: "删除",
                //     show: true,
                //     params: id,
                //     operate: "del"
                // }
            ];
        }
    },
    computed: {
        ToolsData() {
            return [
                {
                    name: "添加系统公告",
                    operate: "add",
                    theme: "primary"
                }
            ];
        },
        SearchsData() {
            return [
                {
                    label: "标题",
                    tag: "vInput",
                    key: "CN_title",
                    show: true
                },
                {
                    label: "状态",
                    tag: "vSelect",
                    key: "EQ_active",
                    show: true,
                    options: [{
                        label: '启用',
                        value: 1
                    }, {
                        label: '停用',
                        value: 0
                    }]
                },
                {
                    label: "创建时间",
                    tag: 'vDatepicker',
                    key: "BT_createdAt",
                    props:{
                        // options:this.options,
                        format:'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm:false,
                    },
                    style: 'width: 180px;',
                    show: true,
                }
            ];
        },
        columns() {
            return [
                {
                    title: "操作",
                    width: 70,
                    render: this.getOperateNodes
                },
                {
                    title: "标题",
                    key: "title",
                    sortable: true
                },
                {
                    title: '状态',
                    key: 'active',
                    sortable: true,
                    render: (h, { row }) => {
                        let item = <span class="deactive">停用</span>
                        if (row.active === 1) {
                            item = <span class="active">启用</span>
                        }
                        return (
                            <div>
                                {item}
                            </div>
                        )
                    }
                },
                {
                    title: "简述",
                    key: "brief"
                },
                {
                    title: '是否过期/过期时间',
                    key: 'expiresAt',
                    render: (h, { row }) => {
                        let isExpires = <span class="hasExpries">已过期</span>
                        if (!row.expired) {
                            isExpires = <span class="notExpries">未过期</span>
                        }
                        return (
                            <div>
                                <div>{isExpires}{row.expiresAt}</div>
                                {/* <div>{row.expiresAt}</div> */}
                            </div>
                        )
                    }
                },
                {
                    title: "创建时间",
                    key: "createdAt"
                }
            ];
        }
    }
};
